export default __webpack_public_path__ + "e7caf260421cae3327e2e64f51e8b3eb.png";